'use client'

import { Cell, Image } from '@vinted/web-ui'

import {
  ModeratedItemAvailabilityStatus,
  ConversationModeratedItem,
} from '@marketplace-web/messaging/conversation-messaging-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { ITEM_URL } from '../../constants/routes'

type Props = {
  item: ConversationModeratedItem
  isSingleItem?: boolean
}

const ModeratedItemCell = ({ item, isSingleItem }: Props) => {
  const translate = useTranslate('conversation.moderated_items')

  const renderImage = (imageUrl: string) => (
    <div>
      <Image
        src={imageUrl}
        ratio={Image.Ratio.Square}
        styling={Image.Styling.Rounded}
        scaling={Image.Scaling.Cover}
        size={Image.Size.Large}
      />
    </div>
  )

  const commonTitle = isSingleItem ? item.title : translate('affected_listing')

  switch (item.availabilityStatus) {
    case ModeratedItemAvailabilityStatus.Visible:
      return (
        <Cell
          prefix={renderImage(item.photoUrl)}
          title={commonTitle}
          body={
            isSingleItem
              ? translate('listing_modified')
              : translate('header.modified', { item: item.title })
          }
          url={ITEM_URL(item.id)}
          type={Cell.Type.Navigating}
          chevron
        />
      )
    case ModeratedItemAvailabilityStatus.Hidden:
      return (
        <Cell
          prefix={renderImage(item.photoUrl)}
          title={commonTitle}
          body={
            isSingleItem
              ? translate('listing_hidden')
              : translate('header.hidden', { item: item.title })
          }
          url={ITEM_URL(item.id)}
          type={Cell.Type.Navigating}
          chevron
        />
      )
    case ModeratedItemAvailabilityStatus.Deleted:
      return (
        <Cell
          prefix={renderImage(item.photoUrl)}
          title={commonTitle}
          body={
            isSingleItem
              ? translate('listing_deleted')
              : translate('header.deleted', { item: item.title })
          }
          disabled
        />
      )
    case ModeratedItemAvailabilityStatus.Expired:
      return (
        <Cell
          prefix={renderImage(item.photoUrl)}
          title={translate('expired')}
          body={translate('expired_description')}
          disabled
        />
      )
    default:
      return null
  }
}

export default ModeratedItemCell
